import {Component, EventEmitter, forwardRef, Inject, OnChanges, Output, SimpleChanges} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PopupServices} from "../../../services/popup.services";
import {Router} from "@angular/router";
import {SessionService} from "../../../services/session.service";
import {TranslateService} from "@ngx-translate/core";
import {Utils} from "../../../model/Utils";
import {TreeviewItem} from "./models/treeview-item";

@Component({
  selector: 'treeItem',
  templateUrl: './TreeItemComponent.html',
  styleUrls: ['./TreeItemComponent.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TreeItemComponent),
      multi: true
    }
  ]
})

export class TreeItemComponent implements ControlValueAccessor, OnChanges {

  @Output()
  checkedChange = new EventEmitter();


  public disabled = false;
  private _onTouchedCallback: any = () => {
  };
  private _onChangedCallback: any = () => {
  };

  item:TreeviewItem | null;


  constructor(
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => PopupServices)) private popupServices: PopupServices,
    @Inject(forwardRef(() => Router)) private router: Router,
    @Inject(forwardRef(() => SessionService)) private session: SessionService,
    @Inject(forwardRef(() => TranslateService)) private translateService: TranslateService
  ) {

  }




  writeValue(obj: any): void {
    // console.log('WriteValues ',obj)
    if (!obj){
      return;
    }
    this.item = obj;
    // this._selectedIds = obj;
    // this._resetSelectableModel();
  }
  registerOnChange(fn: any): void {
    this._onChangedCallback = fn;
    // throw new Error("Method not implemented.");
  }
  registerOnTouched(fn: any): void {
    this._onTouchedCallback = fn;
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    // throw new Error("Method not implemented.");
  }






  ngOnChanges(changes: SimpleChanges): void {
    // console.log('OnChanges: ', changes);
    //this._resetSelectableModel();
  }



  onCollapseExpand () {
    this.item.collapsed = !this.item.collapsed;
  }

  onCheckedChange  ()  {
    const checked = this.item.checked;
    if (!Utils.isNullOrUndefined(this.item.children) /*&& !this.config.decoupleChildFromParent*/) {
      this.item.children.forEach(child => child.setCheckedRecursive(checked));
    }
    this.checkedChange.emit(checked);
  }

  onChildCheckedChange(child: TreeviewItem, checked: boolean): void {
    console.log('On ChildCheckedChange ',checked);
   // if (!this.config.decoupleChildFromParent) {
      let itemChecked: boolean = null;
      for (const childItem of this.item.children) {
        if (itemChecked === null) {
          itemChecked = childItem.checked;
        } else if (itemChecked !== childItem.checked) {
          itemChecked = undefined;
          break;
        }
      }

      if (itemChecked === null) {
        itemChecked = false;
      }

      if (this.item.checked !== itemChecked) {
        this.item.checked = itemChecked;
      }

    //}

    this.checkedChange.emit(checked);
  }


}
